module.exports = __webpack_public_path__ + "static/media/down.01a5b38e.svg";